import {IEntity} from "../../feature/project/story";
import {Link} from "react-router-dom";
import {Card, Col, Flex, Row, Space, Tag} from "antd";
import Meta from "antd/es/card/Meta";
import React, {CSSProperties} from "react";
import {ViewMode} from "./ViewMode";
import ComingSoon from "../../components/ComingSoon";
import Title from "antd/es/typography/Title";

const removeMd = require('remove-markdown');

export interface ListItemProps {
    item: IEntity
    path: string
}

export const List = (props: {
    items: Array<IEntity>,
    viewMode: ViewMode,
    path: (entityId?: number) => string,
    simple?: boolean
}) => {
    const style: CSSProperties = {
        marginTop: 20,
        marginLeft: '-18px',
        padding: '0 18px 18px 18px',
        overflowY: 'auto', scrollbarWidth: "none",
        overflowX: 'visible',
        height: 'calc(100% - 60px)',
        width: 'calc(100% + 36px)'
    }
    return (
        <div style={props.simple ? {} : style}>
            {props.viewMode === ViewMode.List ?
                <Row gutter={[16, 8]}>
                    {props.items.map((item: IEntity) => (
                        <ListItem key={item.id} item={item} path={props.path(item.id)}/>
                    ))}
                </Row> : props.viewMode === ViewMode.Graph ? <ComingSoon/> :
                    <Row gutter={[16, 16]}>
                        {props.items.map((item: IEntity) => (
                            <GridItem key={item.id} item={item} path={props.path(item.id)}/>
                        ))}
                    </Row>
            }
        </div>
    )
}

export const NumericList = (props: {
    items: Array<IEntity>,
    path: (entityId?: number) => string,
    simple?: boolean
}) => {
    const style: CSSProperties = {
        marginTop: 20,
        marginLeft: '-18px',
        padding: '0 18px 18px 18px',
        overflowY: 'auto', scrollbarWidth: "none",
        overflowX: 'visible',
        height: 'calc(100% - 60px)',
        width: 'calc(100% + 36px)'
    }
    return (
        <div style={style}>

            <Row gutter={[16, 8]}>
                {props.items.map((item: IEntity, index: number) => (
                    <NumericListItem number={index + 1} key={item.id} item={item} path={props.path(item.id)}/>
                ))}
            </Row>
        </div>
    )
}

export const ListItem = (props: ListItemProps) => {

    return (
        <Col span={24} key={props.item.id}>
            <Link to={props.path}>
                <Card
                    className={'card-list'}
                    style={{display: 'flex'}}
                    // hoverable
                    cover={
                        <img
                            alt={props.item.title}
                            src={props.item.cover ? props.item.cover : '/images/placeholder.png'}
                            style={{
                                height: '100%',
                                width: 100,
                                objectFit: 'cover',
                                borderRadius: '8px 0 0 8px',
                                marginBottom: '-1px'
                            }}
                        />
                    }
                >
                    <Meta
                        title={props.item.title}
                        description={
                            <Space direction={'vertical'} style={{width: '100%'}}>
                                <div style={{
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden'
                                }}>{removeMd(props.item.description)}</div>
                                <Flex className={'component-tags'}>{props.item.tags?.map(tag =>
                                    <Tag key={tag.id}>{tag.title}</Tag>)}
                                </Flex>
                            </Space>
                        }
                    />
                </Card>
            </Link>
        </Col>
    )
}

export const NumericListItem = (props: {
    item: IEntity
    path: string,
    number: number
}) => {

    return (
        <Col span={24} key={props.item.id}>
            <Link to={props.path}>
                <Card
                    className={'card-list'}
                    style={{display: 'flex'}}
                    // hoverable
                    cover={
                        <Flex
                            justify={'center'}
                            align={'center'}
                            style={{
                                display: 'flex',
                                height: 100,
                                width: 100,
                                borderRadius: '8px 0 0 8px',
                                background: "#eee"
                            }}
                        >
                            <Title level={3} style={{
                                margin: 0,
                                display: 'block',
                                height: 52,
                                aspectRatio: 1,
                                background: "#fff",
                                padding: 10,
                                borderRadius: 100,
                                textAlign: 'center'
                            }}>{props.number}</Title>
                        </Flex>
                    }
                >
                    <Meta
                        title={props.item.title}
                        description={
                            <Space direction={'vertical'} style={{width: '100%'}}>
                                <div style={{
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden'
                                }}>{removeMd(props.item.description)}</div>
                                <Flex className={'component-tags'}>{props.item.tags?.map(tag =>
                                    <Tag key={tag.id}>{tag.title}</Tag>)}
                                </Flex>
                            </Space>
                        }
                    />
                    <div style={{
                        position: 'absolute',
                        right: 0,
                        top: 0,
                        padding: '4px 8px',
                        borderRadius: '0px 6px 0px 6px',
                        border: '1px solid #eee',
                        background: '#eee',
                        fontSize: 12
                    }}>ID: {props.item.id ?? ''}</div>
                </Card>
            </Link>
        </Col>
    )
}

export const GridItem = (props: ListItemProps) => {

    return (
        <Col span={6} key={props.item.id}>
            <Link to={props.path}>
                <Card
                    className={'card-grid'}
                    // hoverable
                    cover={
                        <img
                            alt={props.item.title}
                            src={props.item.cover ? props.item.cover : '/images/placeholder.png'}
                            style={{aspectRatio: 1, objectFit: 'cover'}}
                        />
                    }
                >
                    <Meta
                        title={props.item.title}
                        description={
                            <Space direction={'vertical'} style={{width: '100%'}}>
                                <div style={{
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden'
                                }}>{removeMd(props.item.description)}</div>
                                <Flex className={'component-tags'}
                                      style={{display: "flex", height: 22}}>{props.item.tags?.map(tag => <Tag
                                    key={tag.id}>{tag.title}</Tag>)}</Flex>
                            </Space>
                        }
                    />
                </Card>
            </Link>
        </Col>
    )
}